
























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {PageCollection, Resource} from 'simpli-web-sdk'

@Component
export default class ItRender extends Vue {
  @Prop({required: true}) model!: Resource
  @Prop({type: Array}) fields!: string[]
  @Prop({type: String}) title!: string
  @Prop({type: Number, default: 2}) split!: number
  @Prop({type: Number, default: 0}) index!: number

  get desSplit() {
    return this.split
  }

  get tabSplit() {
    return Math.max(1, this.split - 1)
  }

  get mobSplit() {
    return Math.max(1, this.split - 2)
  }

  get fieldsToRender() {
    return this.fields || this.model.fieldsToRender
  }
}
